<template>
  <div role="alert" class="notifier m-b-20" :class="getType.toLowerCase()">
    <div class="notifier__icon">
      <img src="@/assets/images/icon-error.svg" alt="" />
    </div>
    <div class="notifier__text">
      <p v-if="!$slots || !Object.keys($slots).length" class="notifier__status">{{ data }}</p>
      <p v-else class="notifier__status">
        <slot class="notifier__status"></slot>
      </p>
      <p v-if="isDetails && isCompletedType" class="notifier__link m-l-30" @click="$emit('reorder')">reorder</p>
    </div>
  </div>
</template>

<script>
import { ERROR_DEFAULT } from "../../../../app-constants";

export default {
  name: "AppNotifier",
  props: {
    data: {
      type: String,
      default: ERROR_DEFAULT
    },
    type: String,
    isDetails: Boolean
  },
  data() {
    return {
      completedType: "completed"
    };
  },
  computed: {
    getType() {
      return this.type || "";
    },
    isCompletedType() {
      return this.getType.toString().toLowerCase() === this.completedType;
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .failed {
    color: $primary-color;
    background-color: rgba($error-color, 0.3);
    border-color: $error-color;
  }
}

.notifier {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 60px;
  border-radius: 5px;
  padding-left: 15px;

  &__link {
    cursor: pointer;

    @include respond-to-mobile {
      margin: 0;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  &__status {
    font-family: $fontFamilyPrimary;
    font-size: 14px;
    text-align: left;
    padding-right: 30px;
    @include respond-to-mobile {
      margin: 0;
    }
  }

  &__icon {
    &:last-of-type {
      cursor: pointer;
      position: absolute;
      top: 2px;
      right: 2px;

      img {
        width: 12px;
        height: 12px;
      }
    }
  }

  img {
    margin: 0 0.5em -3px 0;
    width: 25px;
    height: 25px;
  }

  @include respond-to-mobile {
    text-align: center;
  }
}

.completed {
  color: $notifier-completed-text;
  background-color: $notifier-completed-background;
  border: 1px solid $notifier-completed-border;
}

.failed {
  color: $notifier-failed-text;
  background-color: $notifier-failed-background--2;
  border: 1px solid $notifier-failed-border--2;
}

.pending {
  color: $notifier-success-text;
  background-color: $notifier-success-background;
  border: 1px solid $notifier-success-border;
}
</style>
